import SIGNIN_FROM from '../actionTypes/SignInSliderActionTypes';

const signinFrom = (payload) => ({
    type: SIGNIN_FROM,
    payload,
});

export default signinFrom;
